import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, StateApi, stateRequest } from "../../helper";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import moment from "moment";
export default class BirthdaySevaModeration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      postCount: 0,
      status: "Active",
      loadMoreDisplay: false,
      statelist: [],
      constlist: [],
      StateId: "",
      statename: "",
      startDate: new Date().toISOString().slice(0, 10),
      endDate: new Date().toISOString().slice(0, 10),
    };
    this.update = this.update.bind(this);
    this.getPosts = this.getPosts.bind(this);
    this.batchUpdate = this.batchUpdate.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
    this.stateList = this.stateList.bind(this);
    this.constituencyList = this.constituencyList.bind(this);
  }
  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "enabled";
    }

    this.getPosts(status);
    this.stateList();
  }
  componentWillReceiveProps(nextProps) {
    var status = nextProps.match.params.status;
    if (!status) {
      status = "enabled";
    }
    this.setState({ lastEvaluatedKey: "" }, () => {
      this.getPosts(status);
    });
  }
  getPosts(status, loadmore) {
    $("#loader").css({ display: "block" });
    var ref = this;
    if (!loadmore) {
      ref.setState({ items: [] });
    }

    var request = doRequest(
      "cms-operations2",
      {
        action: "list-posts",
        module: "birthdayseva",
        model: "post",
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
        data: {
          direction: "desc",
          status: status,
          limit: 100,
        },
      },
      true
    );
    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...response.items]
            : response.items;
          if (response.items.length > 99) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
          ref.setState(
            {
              response: response,
              items: loadMoreItems,
              lastEvaluatedKey: response.lastEvaluatedKey,
              postCount: response.countdata.Count,
              status: status,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  }
  batchUpdate(status) {
    var ids = [];
    var createds = [];
    $(".multi_select:checked").each(function () {
      ids.push($(this).attr("data-id"));
      createds.push($(this).attr("data-created"));
    });
    var id = ids.join(",");
    var created = createds.join(",");

    if (id == "") {
      alert("No post selected");
    } else {
      this.update(id, created);
    }
  }

  update(id, created, status) {
    id = "" + id;
    var request = doRequest(
      "cms-operations2",
      {
        action: "update-post",
        module: "birthdayseva",
        model: "post",
        data: {
          id: id,
          status: status,
          created: created,
        },
      },
      true
    );

    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          var ids = id.split(",");
          ids.map(function (id_value) {
            $("#post_" + id_value).hide();
          });
        }
      } catch (ex) {}
    });
  }

  selecttype = (e, loadmore) => {
    this.setState({
      selecttype: "hastag",
    });
    $("#loader").css({ display: "block" });
    var ref = this;
    if (!loadmore) {
      ref.setState({ items: [] });
    }

    var request = doRequest(
      "cms-operations2",
      {
        action: "hashtag-post",
        module: "birthdayseva",
        model: "post",
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
        data: {
          id: e,
          limit: 100,
        },
      },
      true
    );
    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...response.items]
            : response.items;
          if (response.items.length > 99) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
          ref.setState(
            {
              response: response,
              items: loadMoreItems,
              lastEvaluatedKey: response.lastEvaluatedKey,
              postCount: response.countdata.Count,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };

  constlisting = (constituency) => {
    this.setState(
      {
        constituencyname: constituency,
        selecttype: "constituency",
        lastEvaluatedKey: "",
      },
      () => {
        this.enterPressed("", this.state.constituencyname);
      }
    );
  };

  enterPressed = (statename, constituency, loadmore) => {
    $("#loader").css({ display: "block" });
    var ref = this;
    if (!loadmore) {
      ref.setState({ items: [] });
    }
    let ep = null;
    if (statename) {
      ep = {
        action: "state-post",
        module: "birthdayseva",
        model: "post",
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
        data: { id: statename, limit: 100 },
      };
    } else if (constituency) {
      ep = {
        action: "constituency-post",
        module: "birthdayseva",
        model: "post",
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
        data: { id: constituency, limit: 100 },
      };
    }
    if (ep) {
      var request = doRequest("cms-operations2", ep, true);
      request.addEventListener("load", function () {
        var response = this.responseText;
        try {
          response = JSON.parse(response);
          if (response._resultflag && response._resultflag == 1) {
            let loadMoreItems = loadmore
              ? [...ref.state.items, ...response.items]
              : response.items;
            if (response.items.length > 99) {
              ref.setState({
                loadMoreDisplay: true,
              });
            } else {
              ref.setState({
                loadMoreDisplay: false,
              });
            }
            ref.setState(
              {
                response: response,
                items: loadMoreItems,
                lastEvaluatedKey: response.lastEvaluatedKey,
                postCount: response.countdata.Count,
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
        } catch (ex) {}
      });
    }
  };
  stateList = () => {
    var form = new FormData();
    form.append("action", "getstatelist");
    form.append(
      "token",
      "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu"
    );
    form.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");

    var settings = {
      url: "https://api.narendramodi.in/mlapiv1",
      method: "POST",
      timeout: 0,
      headers: {
        Cookie:
          "ADRUM_BT=R%3A0%7Cg%3A48c9d406-532c-4eef-98d3-f21dad96c84c6%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29062%7Cd%3A12%7Ce%3A566",
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };
    let ref = this;
    $.ajax(settings).done(function (response) {
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          ref.setState({
            statelist: response.data,
          });
        }
      } catch (ex) {}
    });
  };
  getconstitunecy = async (e) => {
    let stateId = e.target.options[e.target.selectedIndex].dataset.value;

    this.setState(
      {
        statename: e.target.value,
        selecttype: "state",
        lastEvaluatedKey: "",
      },
      () => {
        this.enterPressed(this.state.statename);
      }
    );
    this.setState({
      StateId: stateId,
    });
    this.constituencyList(stateId);
  };

  constituencyList = (stateId) => {
    var form = new FormData();
    form.append("action", "getconstituencylist");
    form.append(
      "token",
      "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu"
    );
    form.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");
    form.append("stateid", stateId);

    var settings = {
      url: "https://api.narendramodi.in/apiv2",
      method: "POST",
      timeout: 0,
      headers: {
        Cookie:
          "ADRUM_BT=R%3A0%7Cg%3A946d93ef-76ab-4cbb-a131-4a70f335905f3%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29063%7Cd%3A14%7Ce%3A122",
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };
    var ref = this;
    $.ajax(settings).done(function (response) {
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          ref.setState({
            constlist: response.data,
          });
        }
      } catch (ex) {}
    });
  };

  loadMoreData = () => {
    let ep = null;
    var status = this.props.match.params.status;
    // this.getPosts(status, "loadmore");
    if (this.state.selecttype == "state") {
      this.enterPressed(this.state.statename, "", "loadmore");
    } else if (this.state.selecttype == "constituency") {
      this.enterPressed("", this.state.constituencyname, "loadmore");
    } else if (this.state.selecttype == "hastag") {
      this.selecttype(this.state.catname, "loadmore");
    } else if (this.state.selecttype == "date") {
      this.submitDate("loadmore");
    } else {
      this.getPosts(status, "loadmore");
    }
  };
  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  loadSubmitDate = () => {
    this.setState({ lastEvaluatedKey: null }, () => {
      this.submitDate();
    });
  };

  submitDate = (loadmore) => {
    if (!this.state.startDate) {
      alert("Please select start date");
      return false;
    }
    if (!this.state.endDate) {
      alert("Please select end date");
      return false;
    }
    $("#loader").css({ display: "block" });

    if (!loadmore) {
      this.setState({ items: [], lastEvaluatedKey: null });
    }

    this.setState({ selecttype: "date" });
    var ref = this;

    var request = doRequest(
      "cms-operations2",
      {
        action: "post-by-date",
        module: "birthdayseva",
        model: "post",
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
        data: {
          start: ref.state.startDate + "T00:00:00.000Z",
          end: ref.state.endDate + "T59:59:59.999Z",
          limit: 100,
        },
      },
      true
    );
    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          console.log("response is ", response.items);
          let items = loadmore
            ? [...ref.state.items, ...response.items]
            : response.items;

          if (response.items.length > 99) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
          ref.setState(
            {
              response: response,
              items: items,
              lastEvaluatedKey: response.lastEvaluatedKey,
              postCount: response.countdata.Count,
              // status: status,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
          $("#loader").css({ display: "none" });

          // let loadMoreItems = loadmore
          //   ? [...this.state.items, ...response.items]
          //   : response.items;
          // if (response.items.length > 99) {
          //   this.setState({
          //     loadMoreDisplay: true,
          //   });
          // } else {
          //   this.setState({
          //     loadMoreDisplay: false,
          //   });
          // }
          // this.setState(
          //   {
          //     response: response,
          //     items: loadMoreItems,
          //     lastEvaluatedKey: response.lastEvaluatedKey,
          //     postCount: response.countdata.Count,
          //     // status: status,
          //   },
          //   () => {
          //     $("#loader").css({ display: "none" });
          //   }
          // );
        }
      } catch (ex) {
        $("#loader").css({ display: "none" });
      }
    });
  };

  render() {
    var bread = "BirthdaySeva / Moderation (Active Posts)";
    var pagelink = "/birthdayseva/moderation";
    if (this.props.match.params.status == "disabled") {
      bread = "BirthdaySeva/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else {
      pagelink += "/enabled";
    }
    var items = this.state.items;
    var stateList = this.state.statelist;
    var constList = this.state.constlist;
    var links = [
      {
        link: "/birthdayseva/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/birthdayseva/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }
    return (
      <div>
        <PageTitle
          title="#BirthdaySeva"
          bread={bread}
          links={links}
          Count={this.state.postCount}
          counttype={
            this.state.status == "enabled"
              ? "Active "
              : this.state.status == "disabled"
              ? "Inactive "
              : ""
          }
        />
        <div className="wrapper wrapper-content">
          <div className="form-inline form_right">
            <div className="padding_select">
              <select
                id="state"
                name="state"
                // className="bdaydrop_down"
                className="form-control rigt_mar"
                onChange={(e) => this.getconstitunecy(e)}
              >
                <option value="">Select Your State</option>
                {Array.isArray(stateList) &&
                  stateList.map((val, i) => {
                    return (
                      <option
                        value={val.statename}
                        key={i}
                        data-value={val.stateid}
                      >
                        {val.statename}
                      </option>
                    );
                  })}
              </select>
              <select
                // className="bdaydrop_down"
                className="form-control rigt_mar"
                id="constituency"
                name="constituency"
                onChange={(e) => this.constlisting(e.target.value)}
              >
                <option value="">Select Your Constituency</option>
                {Array.isArray(constList) &&
                  constList.map((val, i) => {
                    return (
                      <option value={val.boothname} key={i}>
                        {val.boothname}
                      </option>
                    );
                  })}
              </select>
              {this.props.match.params.status == "disabled" ? (
                ""
              ) : (
                <select
                  // className="bdaydrop_down"
                  className="form-control"
                  onChange={(e) =>
                    this.setState(
                      {
                        catname: e.target.value,
                        lastEvaluatedKey: "",
                      },
                      () => {
                        this.selecttype(this.state.catname);
                      }
                    )
                  }
                >
                  <option value="">Select Category Hashtag</option>
                  <option value="#LiFEProPlanet">#LiFEProPlanet</option>
                  <option value="#VocalForLocal">#VocalForLocal</option>
                  <option value="#DigitalIndia">#DigitalIndia</option>
                  <option value="#TBFreeIndia">#TBFreeIndia</option>
                  <option value="#AatmanirbharBharat">
                    #AatmanirbharBharat
                  </option>
                  <option value="#CatchTheRain">#CatchTheRain</option>
                  <option value="#EkBharatShreshthBharat">
                    #EkBharatShreshthBharat
                  </option>
                  <option value="#DonateBlood">#DonateBlood</option>
                  <option value="#SwachhBharat">#SwachhBharat</option>
                </select>
              )}
              <button
                className="btn-success"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear filters
              </button>
            </div>
          </div>
          <div className="row row_date_div">
            <div className="col-md-2">
              <label htmlFor="startDate">Start Date</label>
              {/* <DatePicker
                selected={this.state.startDate}
                onChange={(date) => this.setState({ startDate: date })}
                dateFormat="DD/MM/YYYY"
                placeholderText="Start date"
              /> */}
              <input
                id="startDate"
                className="form-control"
                type={"date"}
                defaultValue={this.state.startDate}
                onChange={(e) => this.setState({ startDate: e.target.value })}
              />
            </div>
            <div className="col-md-2">
              <label htmlFor="">End Date</label>
              {/* <DatePicker
                selected={this.state.endDate}
                onChange={(date) => this.setState({ endDate: date })}
                dateFormat="DD/MM/YYYY"
                placeholderText="End date"
              /> */}
              <input
                id="endDate"
                type={"date"}
                className="form-control"
                defaultValue={this.state.endDate}
                onChange={(e) => this.setState({ endDate: e.target.value })}
              />
            </div>
            <div className="col-md-2">
              <button
                onClick={() => this.loadSubmitDate()}
                className="btn btn-primary"
              >
                Submit
              </button>
            </div>
          </div>
          <br />
          <br />
          {items.length === 0 && (
            <p
              id="nodatafound"
              style={{
                // display: "none",
                textAlign: "center",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "20px",
              }}
            >
              No Data Found
            </p>
          )}
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <img
                                  alt="image"
                                  class="img-responsive"
                                  src={value.post_url}
                                />
                                <div className="image_caption">
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-warning btn-circle"
                                    onClick={() => {
                                      this.update(
                                        value.id,
                                        value.created,
                                        "disable"
                                      );
                                    }}
                                    type="button"
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              <span>
                                {value.user_name ? value.user_name : ""}
                              </span>
                              <br />
                              <span>
                                {value.category_hashtag != "null"
                                  ? value.category_hashtag
                                  : " "}
                              </span>
                              <br />
                              <small>
                                Added: {value.created ? value.created : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/BirthdaySeva/Moderation.jsx